export default __webpack_public_path__ + "static/media/Transformer_00.6cbae2ff.png";